export const AUTH_TYPE = {
  EMAIL_AND_PASSWORD: 'email_and_password',
  SSO: 'sso',
  SOCIAL: 'social',
};

export type AuthType = (typeof AUTH_TYPE)[keyof typeof AUTH_TYPE];
